import { Card } from 'antd';
import { Content } from 'antd/lib/layout/layout';
import * as React from 'react';
import { RouteComponentProps, withRouter } from 'react-router-dom';
import TransferMajorCourseBlockDataTable from '../../../../components/datatables/postSecondary/TransferMajorCourseBlockDataTable';
import Breadcrumbs from '../../../../config/Breadcrumbs';
import HeaderPortal from '../../../../portals/HeaderPortal';
import HistoryUtil from '../../../../utils/HistoryUtil';

interface TransferMajorCourseBlockListProps {
}

interface TransferMajorCourseBlockListState {
}

class TransferMajorCourseBlockListPage extends React.Component<TransferMajorCourseBlockListProps & RouteComponentProps<RouteObject>, TransferMajorCourseBlockListState> {
  constructor(props: TransferMajorCourseBlockListProps & RouteComponentProps<RouteObject>) {
    super(props);
  }

  private goToConfig = () => {
    HistoryUtil.goBack();
  }

  render() {
    return (
      <Content>
        <HeaderPortal title="Transfer Major Course Blocks" onBack={this.goToConfig} breadcrumbs={Breadcrumbs.transferMajorCourseBlockList()} />
        <Card >
          <TransferMajorCourseBlockDataTable />
        </Card>
      </Content>
    );
  }
}

export default withRouter(TransferMajorCourseBlockListPage);
